// PWA utilities for handling installation and updates

class PWAManager {
  constructor() {
    this.deferredPrompt = null;
    this.isInstalled = false;
    this.updateAvailable = false;
    this.listeners = {
      onInstallPrompt: [],
      onAppInstalled: [],
      onUpdateAvailable: [],
    };
  }

  /**
   * Initialize PWA features
   */
  init() {
    this.checkIfInstalled();
    this.handleBeforeInstallPrompt();
    this.handleAppInstalled();
  }

  /**
   * Check if app is already installed
   */
  checkIfInstalled() {
    if (window.matchMedia('(display-mode: standalone)').matches) {
      this.isInstalled = true;
    }

    if (navigator.standalone === true) {
      this.isInstalled = true;
    }
  }

  /**
   * Handle beforeinstallprompt event
   */
  handleBeforeInstallPrompt() {
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      this.deferredPrompt = e;
      this.notifyListeners('onInstallPrompt', e);
    });
  }

  /**
   * Handle app installed event
   */
  handleAppInstalled() {
    window.addEventListener('appinstalled', () => {
      this.isInstalled = true;
      this.deferredPrompt = null;
      this.notifyListeners('onAppInstalled');
    });
  }

  /**
   * Prompt user to install app
   */
  async promptInstall() {
    if (!this.deferredPrompt) {
      console.log('Install prompt is not available');
      return false;
    }

    this.deferredPrompt.prompt();
    const { outcome } = await this.deferredPrompt.userChoice;
    console.log(`User response to install prompt: ${outcome}`);
    this.deferredPrompt = null;
    return outcome === 'accepted';
  }

  /**
   * Check for app updates
   */
  checkForUpdates() {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.controller?.postMessage({
        type: 'CHECK_UPDATES',
      });
    }
  }

  /**
   * Subscribe to PWA events
   */
  on(event, callback) {
    if (this.listeners[event]) {
      this.listeners[event].push(callback);
    }
  }

  /**
   * Unsubscribe from PWA events
   */
  off(event, callback) {
    if (this.listeners[event]) {
      this.listeners[event] = this.listeners[event].filter(
        (listener) => listener !== callback
      );
    }
  }

  /**
   * Notify all listeners
   */
  notifyListeners(event, data) {
    if (this.listeners[event]) {
      this.listeners[event].forEach((callback) => {
        callback(data);
      });
    }
  }

  /**
   * Get installation status
   */
  getInstallationStatus() {
    return {
      isInstalled: this.isInstalled,
      canPromptInstall: !!this.deferredPrompt,
      updateAvailable: this.updateAvailable,
    };
  }
}

// Export singleton instance
export default new PWAManager();
